import useSWR from 'swr';
import type { Leasing } from '~/models/Leasing';
import type { SwrReturnType } from '~/models/Api';

const paths = {
  show: '/kt_leasings/:leasing_id'
};
type TLeasingInfo = (leasingId: string | null) => SwrReturnType<Leasing>;
type ReturnType = {
  leasingInfo: TLeasingInfo;
};

export const useKtLeasings = (): ReturnType => {
  const leasingInfo: TLeasingInfo = (leasingId: string | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<Leasing>(
      leasingId == null ? null : paths.show.replace(':leasing_id', leasingId)
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { leasingInfo };
};
